import React from "react";
import AnimatedSvgGroup from "../../animatedSvgBits/AnimatedGroup";
import AnimatedSvgThing from "../../animatedSvgBits/AnimatedSvgThing";

export default function Spool({
  tapeRadius,
  progress = 0,
  maxRotation,
  timings,
  isTransparent,
}) {
  const tapeColour = "#3f2b26";
  const outlineColour = "rgba(0,0,0,0.4)"; //grey
  const strokeWidth = 0.4;

  let rot = progress * maxRotation;
  if (isNaN(rot)) {
    rot = 0;
  }

  return (
    <g display="inline" transform={`rotate(${rot} 56.857 56.668)`}>
      <g strokeLinejoin="round" strokeMiterlimit="4">
        {/* TAPE */}
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          timings={timings}
          progress={progress}
          strokeWidth={strokeWidth}
          stroke={tapeColour}
          type={"circle"}
          cx="56.857"
          cy="56.668"
          r={tapeRadius}
          fill={tapeColour}
        />

        {/* SPOOL */}
        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="path"
          durationMultiplier={1}
          timings={timings}
          progress={progress}
          maxOpacity="0.606"
          fill="#fff"
          stroke={outlineColour}
          strokeWidth="0.4"
          d="M56.735 2.548a54.3 54.12 0 00-54.179 54.12 54.3 54.12 0 0054.302 54.119 54.3 54.12 0 0054.3-54.12 54.3 54.12 0 00-54.3-54.119 54.3 54.12 0 00-.123 0zm-.156 5.098c5.494-.063 10.76 1.218 16.639 3.523 4.709 2.51 2.615 5.503 0 8.272 0 0-4.986 5.452-8.924 9.485-.74.759-1.53 1.376-2.352 1.85-3.544 2.053-8.888 1.456-12.086-1.85-3.938-4.071-8.924-9.485-8.924-9.485-2.254-2.387-4.183-6.404 0-8.272C46.71 8.803 51.732 7.7 56.58 7.646zM28.57 18.638c2.248.074 3.287 2.542 4.085 5.188 0 0 2.245 7.03 3.78 12.445a10.94 10.94 0 01.433 2.955c.01 4.085-3.18 8.4-7.652 9.507-5.507 1.364-12.704 2.96-12.704 2.96-3.2.752-7.655.408-7.187-4.136 1.775-13.16 6.84-20.486 16.143-27.867 1.133-.702 2.08-1.023 2.881-1.051.075-.003.149-.003.221 0zm57.227.694c.774-.017 1.629.256 2.557.925 10.548 8.112 14.38 16.147 16.143 27.867.174 5.319-3.474 5.008-7.187 4.135 0 0-7.23-1.577-12.704-2.96-1.03-.26-1.96-.633-2.784-1.103-3.555-2.034-5.71-6.945-4.436-11.358 1.57-5.435 3.781-12.446 3.781-12.446.71-2.354 2.308-5.009 4.63-5.06zm-72.96 41.199c1.032.008 2.187.226 3.347.499 0 0 7.23 1.576 12.704 2.96 1.03.26 1.96.633 2.784 1.104 3.555 2.033 5.709 6.944 4.435 11.357-1.568 5.435-3.78 12.446-3.78 12.446-.947 3.14-3.472 6.812-7.187 4.136C14.592 84.92 10.758 76.885 8.996 65.166c-.12-3.657 1.568-4.654 3.84-4.635zm86.684.755c2.581-.008 4.999 1.037 4.648 4.446-1.776 13.16-6.84 20.486-16.143 27.867-4.535 2.81-6.089-.494-7.187-4.136 0 0-2.246-7.03-3.78-12.445a10.94 10.94 0 01-.433-2.955c-.01-4.085 3.18-8.4 7.652-9.507 5.507-1.363 12.704-2.96 12.704-2.96a11.43 11.43 0 012.54-.31zM56.09 81.325c2.712-.036 5.549.972 7.547 3.038 3.939 4.071 8.924 9.486 8.924 9.486 2.255 2.386 4.184 6.403 0 8.27-12.323 5.049-21.22 4.34-32.285 0-4.709-2.508-2.615-5.502 0-8.27 0 0 4.986-5.453 8.924-9.486.74-.759 1.53-1.376 2.351-1.85 1.33-.77 2.911-1.167 4.539-1.188z"
        />

        <AnimatedSvgThing
          className={`tapeComponent ${isTransparent && "transparent"}`}
          type="ellipse"
          timings={timings}
          progress={progress}
          id="centerDisk"
          cx="56.857"
          cy="56.668"
          fill="#fff"
          maxOpacity="0.918"
          strokeWidth={strokeWidth}
          stroke={tapeColour}
          rx="20.018"
          ry="20.018"
        />

        <AnimatedSvgGroup
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="Screw"
          timings={timings}
          progress={progress}
          strokeOpacity="0.702"
          strokeWidth="0.148"
          transform="rotate(45 29.273 -448.87) scale(1.78571)"
        >
          <circle
            className={`tapeComponent ${isTransparent && "transparent"}`}
            cx="227.499"
            cy="-62.107"
            r="1.323"
            fill="url(#wheelScrewHead)"
            stroke="#333"
          />
          <path
            className={`tapeComponent ${isTransparent && "transparent"}`}
            fill="#4d4d4d"
            stroke="none"
            d="M227.493-63.383c.303.05.27 2.536 0 2.599-.271-.066-.283-2.61 0-2.599z"
          />
        </AnimatedSvgGroup>
      </g>
    </g>
  );
}
